import { useState } from 'react'
import { MapPin, X } from 'lucide-react'
import { Modal, Button, ButtonVariant, ButtonStyle, H3, Body } from '@meiuca/ui-components'
import { UserLocationAutocomplete } from './UserLocationAutocomplete'
import { useUserLocation, UserLocation } from '@/hooks/useUserLocation'

interface MarketplaceLocationPromptProps {
  open: boolean
  onClose: () => void
}

export function MarketplaceLocationPrompt({ open, onClose }: MarketplaceLocationPromptProps) {
  const { updateUserLocation } = useUserLocation()
  const [selectedLocation, setSelectedLocation] = useState<UserLocation | null>(null)

  const handleLocationChange = (location: UserLocation | null) => {
    setSelectedLocation(location)
  }

  const handleConfirm = () => {
    if (selectedLocation) {
      updateUserLocation(selectedLocation)
      onClose()
      // Recarrega a página para atualizar o conteúdo baseado na localização
      window.location.reload()
    }
  }

  const handleSkip = () => {
    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={handleSkip}
      size="md"
      closeOnOverlayClick={false}
      showCloseButton={false}
    >
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-brand-primary/10 rounded-full flex items-center justify-center">
              <MapPin className="w-6 h-6 text-brand-primary" />
            </div>
            <div>
              <H3 className="text-text-primary">Onde você está?</H3>
              <Body className="text-text-secondary text-sm">
                Para mostrar arenas próximas a você
              </Body>
            </div>
          </div>
          <button
            onClick={handleSkip}
            className="p-2 hover:bg-background-secondary rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-text-tertiary" />
          </button>
        </div>

        {/* Location Autocomplete */}
        <div>
          <UserLocationAutocomplete
            value={selectedLocation}
            onChange={handleLocationChange}
            placeholder="Digite seu bairro ou cidade..."
          />
        </div>

        {/* Actions */}
        <div className="flex items-center justify-between gap-3">
          <Button
            buttonStyle={ButtonStyle.CLEAR}
            onClick={handleSkip}
          >
            Pular por enquanto
          </Button>
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={handleConfirm}
            disabled={!selectedLocation}
          >
            Confirmar localização
          </Button>
        </div>

        {/* Info */}
        <Body className="text-text-tertiary text-xs text-center">
          Você pode alterar sua localização a qualquer momento
        </Body>
      </div>
    </Modal>
  )
}
